import { Spin } from "antd";
import { FormikProps } from "formik";
import { useState } from "react";
import ReactHtmlParser from "react-html-parser";
import { useTranslation } from "react-i18next";

import { IArticle, IArticleImage } from "../../../../../../@types/Articles";
import { ReactComponent as MissingImage } from "../../../../../../assets/images/missing-image.svg";
import {
  Card,
  CardContainer,
  CardContent,
  CardDescription,
  CardDetailsContainer,
  CardImageContainer,
  CardSubtitle,
  CardTitle,
  ContentContainer,
  IFrameContainer,
  spinCss,
} from "./PreviewSection.styles";

interface IPreviewSectionProps {
  formik: FormikProps<IArticle>;
  images: IArticleImage[];
}

export function PreviewSection({ formik, images }: IPreviewSectionProps) {
  const { t } = useTranslation();

  const [isArticleLoading, setIsArticleLoading] = useState(true);

  const handleCardImage = () => {
    const cardImage = images.find((x) => x.key === formik.values.imageName);

    if (cardImage) {
      return <img src={cardImage.preSignedUrl} alt={cardImage.key} />;
    }

    return <MissingImage />;
  };

  return (
    <ContentContainer>
      <Card>
        <CardTitle>{t("careInfo_preview_carePlan")}</CardTitle>
        <CardContainer>
          <CardImageContainer>{handleCardImage()}</CardImageContainer>
          <CardDetailsContainer>
            <CardSubtitle>
              {formik.values.title !== ""
                ? formik.values.title
                : t("careInfo_preview_title")}
            </CardSubtitle>
            <CardDescription>
              {formik.values.description !== ""
                ? formik.values.description
                : t("careInfo_preview_descriptionPlaceholder")}
            </CardDescription>
          </CardDetailsContainer>
        </CardContainer>
      </Card>

      <Card>
        {formik.values.articleUrl === undefined ? (
          <>
            <CardTitle>
              {formik.values.title !== ""
                ? formik.values.title
                : t("careInfo_preview_title")}
            </CardTitle>
            <CardContent>
              {formik.values.articleText !== ""
                ? ReactHtmlParser(formik.values.articleText ?? "")
                : t("careInfo_preview_contentPlaceholder")}
            </CardContent>
          </>
        ) : (
          <>
            {isArticleLoading ? (
              <Spin className={spinCss()} size="large" />
            ) : null}
            <IFrameContainer isLoading={isArticleLoading}>
              <iframe
                title="article-preview"
                src={formik.values.articleUrl}
                style={{ width: "330px", height: "620px", border: "0px" }}
                onLoad={() => setIsArticleLoading(false)}
              />
            </IFrameContainer>
          </>
        )}
      </Card>
    </ContentContainer>
  );
}
